// extracted by mini-css-extract-plugin
module.exports = {"toggleIcon":"index_toggleIcon_TceC6"};